import selector from 'focusable';

export default function getFocusables(element) {
    const elements = element.matches(selector) ? [element] : element.querySelectorAll(selector);
    return Array.prototype.filter.call(elements, function (element) {
        // assert element is displayed
        return element.offsetParent !== null;
    });
}

if (typeof jQuery === 'function') {
    // eslint-disable-next-line
    jQuery.fn.focusables = function () {
        return getFocusables(this.get(0));
    };
}
